import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Preloader } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import Topbar from '@/modules/core/components/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { HealthPlanSpendTrackerDetails } from '@/modules/deductibles/HealthPlanDetails/HealthPlanSpendTrackerDetails';
import { useGetEmployeeById } from '@/modules/employee/Employee/hooks';
import theme from '@/styles/theme';

const HealthPlanSpendTrackerDetailsPage = () => {
  const { id, healthPlanId, yearId } = useParams<{ id: string; healthPlanId: string, yearId: string }>();
  const [healthPlanName, setHealthPlanName] = useState<string>();
  const { isLoading, data: employeeData } = useGetEmployeeById();

  useBreadcrumbs(
    [
      {
        route: ROUTES.EMPLOYEES,
        title: '...',
      },
      {
        route: `${ROUTES.EMPLOYEE}/${id}`,
        title: employeeData?.fullName || '',
      },
      {
        route: ROUTES.HEALTH_PLAN_SPENDS_DETAILS(id, healthPlanId, yearId),
        title: healthPlanName || '',
      },
    ],
    [id, healthPlanName, employeeData, healthPlanId, yearId],
    {
      backBtn: true,
    }
  );

  if (isLoading) {
    return (
      <Box width="100%" height="100%" align="center" pad={{ top: 'm' }}>
        <Preloader testId="health-plan-spend-tracker" />
      </Box>
    );
  }

  return (
    <Box width="100%" margin={{ top: '0', bottom: 'xxxl' }} height="fit-content">
      <Topbar />
      <Box align="center" pad={{ horizontal: '40px' }} margin={{ top: 'medium' }}>
        <Box width={theme.defaultContentWidth}>
          <HealthPlanSpendTrackerDetails
            healthPlanName={healthPlanName}
            onHealthPlanNameChange={setHealthPlanName}
            healthPlanYearId={yearId}
            employeeData={employeeData}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default HealthPlanSpendTrackerDetailsPage;
